export const QUESTION_PROBLEM_BANK = 'question_problem_bank'
